
import ogPagesMixins from '@/mixins/ogPagesMixins'
export default {
  mixins: [ogPagesMixins],
  scrollToTop: true,
  data() {
    return {
      seoTitle: 'Компании с акциями | Мегасреда',
      seoDescription:
        'В этом разделе мы собрали компании, готовые предоставить лучшие цены по своим продуктам и сервисам. Действующие скидки и акции от представленных компаний позволяют сэкономить до 70 % стоимости. Многие сервисы и продукты компаний можно получить бесплатно в рамках тест-драйва.',
      seoH1:
        'Все компании поставщики продуктов и сервисов для бугалтеров, юристов, кадровиков и предпринимателей.',
      seoImage: {
        url: 'https://megasreda.ru/img/products/events_ogg.jpg',
        urlVk: 'https://megasreda.ru/img/products/events_ogg-vk.jpg',
        urlTw: 'https://megasreda.ru/img/products/events_ogg.jpg',
        type: 'image/jpeg',
        width: 1200,
        height: 630,
      },
      companys: null,
      countAllCompanys: null,
      filterMenu: [],
    }
  },
  async fetch() {
    await this.fetchCompanys()
  },
  methods: {
    async fetchCompanys() {
      try {
        const { companys, countAllCompanys } = await this.$axios.$get(
          '/companys/have/products'
        )
        this.companys = companys
        this.countAllCompanys = countAllCompanys
      } catch (error) {
        console.log(error)
      }
    },
  },
}
